module.exports = __webpack_public_path__ + "img/14-2.26e962ef.png";